// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3FDxB","label":"Radio_label__2mQ4T","checkMark":"Radio_checkMark__a_hoy","disabled":"Radio_disabled__3vZmO"};